// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3652":"7da4363fdf22e87d","5267":"f9e8760191f4ae54","5767":"92643e9cce5041ad"}[chunkId] + ".css";
};